import { HashLink } from "react-router-hash-link";
import { CategoryItem } from "components/fastOrdering/Category";
import Formatter from "hoc/Formatter";
import {
  Routes,
  Route,
  Router,
  useNavigate,
  useLocation,
  Navigate,
  Outlet,
  useParams,
  Link,
  Switch,
  NavLink,
} from "react-router-dom";
import { useState, useEffect } from "react";
import styles from "../shop/shop.module.css";
import { connection } from "utils/apiConnection.ts";

import image from "assets/images/Bakery.png";
import image2 from "assets/images/Protein.png";
import image3 from "assets/images/FruitsandVegetables.png";
import image4 from "assets/images/sweet.svg";
import flower from "assets/images/Flowers.png";
import pharmacy from "assets/images/Medicine.png";
import coffee from "assets/images/New folder/coffee.png";
import food2 from "assets/images/New folder/food2.png";
import juice from "assets/images/JuiceCoffee.png";
import pet from "assets/images/PetShop.png";
import Loader from "utils/Loader";

export default function ListLines({ listLines, setListLines, vegetable }) {
  const [cats, setCats] = useState([
    { src: image3, title: "" }, //میوه و سبزی
    { src: image2, title: "" }, //محصولات پروتئینی
    { src: image, title: "" }, //نان و شیرینی
    { src: flower, title: "" }, //گل
    { src: juice, title: "" }, //کافه و آبمیوه
    { src: pharmacy, title: "" }, //داروخانه
    { src: pet, title: "" }, //پت شاپ
    { src: image, title: "" }, //سوپرمارکت
    { src: food2, title: "" }, //محصولات غذای خانگی
  ]);
  const [isLoading, setIsLoading] = useState(false);

  let params = useParams();
  useEffect(() => {
    setIsLoading(true);

    connection("api/getcats").then((data) => {
      for (let i = 0; i < data.data.length; i++) {
        setCats((prev) => {
          cats[i] = { src: cats[i].src, title: data.data[i], id: i };
          return cats;
        });
      }
      setIsLoading(false);
    });
  }, [cats]);
  console.log("cats", cats);
  console.log("params", params.lineId);
  console.log("this is listlines page");
  return (
    // <div className="">
    <div className="nav3 d-flex flex-wrap ">
      {isLoading && <Loader />}

      {cats.map((value, index) => {
        return (
          <NavLink
            target="_blank"
            to={`/all-lines/${value.id}`}
            className="col-lg-2 col-md-3 col-sm-4 col-6"
            style={{ color: "black", textDecoration: "none" }}
          >
            <CategoryItem
              img={value.src}
              title={value.title}
              backgroundColor={"red"}
            ></CategoryItem>
          </NavLink>
        );
      })}
      {/* ----------------------line list -------------------*/}
      {/* {listLines.map((value, index) => {
          return (
            <Link
              target="_blank"
              to={`/all-lines/${value.main.suppliers_line__id}`}
              style={{ color: "black", textDecoration: "none" }}
            >
              <div>
                <div className="card" key={index}>
                  {value.main.path != null ? (
                    <div className="card-body" style={{ cursor: "pointer" }}>
                      <img
                        src={`http://sabadi.tatdemo.ir/${value.main.path}`}
                        alt={`${value.main.title}`}
                      />
                      <br />
                      <div className="title">{value.main.title}</div>
                    </div>
                  ) : (
                    <div className="card-body" style={{ cursor: "pointer" }}>
                      <img src={vegetable} alt={`${value.main.title}`} />
                      <br />
                      <div className="title">{value.main.title} </div>
                    </div>
                  )}
                </div>
              </div>
            </Link>
          );
        })} */}
    </div>
    // </div>
  );
}
